/**
 * Tiny global busy registry — lets the stale-chunk auto-reload in main.tsx
 * know the app is mid-action (file uploads in flight, a chat turn
 * streaming) so it can DEFER the recovery reload instead of yanking the
 * page out from under the user. Counter-based so overlapping operations
 * compose; window-scoped so main.tsx can read it without importing app
 * code before React mounts.
 */

declare global {
  interface Window {
    __ajoBusyCount?: number;
  }
}

export function acquireBusy(): void {
  window.__ajoBusyCount = (window.__ajoBusyCount || 0) + 1;
}

export function releaseBusy(): void {
  window.__ajoBusyCount = Math.max(0, (window.__ajoBusyCount || 0) - 1);
}

export function isBusy(): boolean {
  return (window.__ajoBusyCount || 0) > 0;
}
